const LocaleActionType = {
  GET_LOCALE_RESOURCES: 'GET_LOCALE_RESOURCES',
  SAVE_LOCALE_RESOURCES: 'SAVE_LOCALE_RESOURCES',

  CHANGE_LOCALE_LANGUAGE: 'CHANGE_LOCALE_LANGUAGE',
};
export default LocaleActionType;
